import React from 'react';
import {
  Utensils, Pizza, Coffee, IceCream, Beef, Salad, Wine, Sandwich, Cookie, Soup,
  Fish, Drumstick, CupSoda, Croissant, Beer, GlassWater, Milk, Egg, Apple,
  CakeSlice, Carrot, Cherry, Grape, Ham, Popcorn, Donut, Wheat, ChefHat,
  Bike, ShoppingBag, Flame, Leaf, Star, Citrus, Droplets, Package, Layers, CookingPot, CirclePlus
} from 'lucide-react';

// Íconos disponibles para las tarjetas de grupo del POS (pendiente #91).
// La clave es lo que se guarda en productos_grupo.icono.
export const ICONOS_GRUPO = [
  { value: 'utensils', label: 'Cubiertos', Comp: Utensils },
  { value: 'pizza', label: 'Pizza', Comp: Pizza },
  { value: 'sandwich', label: 'Sándwich', Comp: Sandwich },
  { value: 'salad', label: 'Ensalada', Comp: Salad },
  { value: 'soup', label: 'Sopa', Comp: Soup },
  { value: 'beef', label: 'Carne', Comp: Beef },
  { value: 'drumstick', label: 'Pollo', Comp: Drumstick },
  { value: 'fish', label: 'Pescado', Comp: Fish },
  { value: 'ham', label: 'Jamón / charcutería', Comp: Ham },
  { value: 'egg', label: 'Huevo / desayuno', Comp: Egg },
  { value: 'croissant', label: 'Panadería', Comp: Croissant },
  { value: 'wheat', label: 'Pastas / granos', Comp: Wheat },
  { value: 'coffee', label: 'Café', Comp: Coffee },
  { value: 'cupsoda', label: 'Refrescos', Comp: CupSoda },
  { value: 'glasswater', label: 'Agua', Comp: GlassWater },
  { value: 'milk', label: 'Lácteos / batidos', Comp: Milk },
  { value: 'wine', label: 'Vinos', Comp: Wine },
  { value: 'beer', label: 'Cervezas', Comp: Beer },
  { value: 'icecream', label: 'Helados', Comp: IceCream },
  { value: 'cakeslice', label: 'Postres / tortas', Comp: CakeSlice },
  { value: 'cookie', label: 'Galletas', Comp: Cookie },
  { value: 'donut', label: 'Donas', Comp: Donut },
  { value: 'popcorn', label: 'Snacks', Comp: Popcorn },
  { value: 'apple', label: 'Frutas', Comp: Apple },
  { value: 'carrot', label: 'Vegetales', Comp: Carrot },
  { value: 'cherry', label: 'Cereza', Comp: Cherry },
  { value: 'grape', label: 'Uva', Comp: Grape },
  { value: 'leaf', label: 'Vegetariano', Comp: Leaf },
  { value: 'flame', label: 'Parrilla / picante', Comp: Flame },
  { value: 'chefhat', label: 'Especiales del chef', Comp: ChefHat },
  { value: 'bike', label: 'Delivery', Comp: Bike },
  { value: 'shoppingbag', label: 'Para llevar', Comp: ShoppingBag },
  { value: 'star', label: 'Destacados', Comp: Star },
  { value: 'citrus', label: 'Jugos / cítricos', Comp: Citrus },
  { value: 'droplets', label: 'Aguas saborizadas', Comp: Droplets },
  { value: 'package', label: 'Empaques / desechables', Comp: Package },
  { value: 'layers', label: 'Combos', Comp: Layers },
  { value: 'cookingpot', label: 'Horno / guisos', Comp: CookingPot },
  { value: 'circleplus', label: 'Extras / adicionales', Comp: CirclePlus }
];

const MAPA = Object.fromEntries(ICONOS_GRUPO.map((i) => [i.value, i.Comp]));

export default function IconoGrupo({ nombre, size = 22, className = '' }) {
  const Comp = MAPA[(nombre || '').toLowerCase()] || Utensils;
  return <Comp size={size} className={className} />;
}
